import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './StorageBar.css';

function formatBytes(bytes) {
  if (bytes >= 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  if (bytes >= 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${bytes} B`;
}

function barColor(percent) {
  if (percent >= 95) return 'var(--danger)';
  if (percent >= 80) return '#f58220';  // orange warning
  return 'var(--accent)';
}

export default function StorageBar({ compact = false, onStorageLoaded }) {
  const [storage, setStorage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/auth/storage')
      .then(({ data }) => {
        setStorage(data);
        onStorageLoaded?.(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [onStorageLoaded]);

  if (loading) return <div className={`storage-bar ${compact ? 'storage-bar--compact' : ''}`}><div className="spinner" style={{ width: 16, height: 16 }} /></div>;
  if (!storage) return null;

  const { usedBytes, limitBytes, availableBytes, usedPercent } = storage;
  const color = barColor(usedPercent);
  const isFull = usedPercent >= 100;

  return (
    <div className={`storage-bar ${compact ? 'storage-bar--compact' : ''} ${isFull ? 'storage-bar--full' : ''}`}>
      {!compact && (
        <div className="storage-bar__header">
          <span className="storage-bar__label">Storage</span>
          <span className="storage-bar__numbers">
            <strong style={{ color }}>{formatBytes(usedBytes)}</strong>
            {' '}/{' '}{formatBytes(limitBytes)}
          </span>
        </div>
      )}

      <div className="storage-bar__track">
        <div
          className="storage-bar__fill"
          style={{ width: `${Math.min(100, usedPercent)}%`, background: color }}
        />
      </div>

      <div className="storage-bar__footer">
        {compact ? (
          <span style={{ color: usedPercent >= 80 ? color : 'var(--text-dim)' }}>
            {formatBytes(usedBytes)} / {formatBytes(limitBytes)} ({usedPercent}%)
          </span>
        ) : (
          <>
            <span className={`storage-bar__status ${isFull ? 'storage-bar__status--full' : ''}`}>
              {isFull
                ? '🚫 Storage full — delete files to upload more'
                : usedPercent >= 80
                ? `⚠ ${formatBytes(availableBytes)} remaining`
                : `${formatBytes(availableBytes)} available`}
            </span>
            <span className="storage-bar__percent">{usedPercent}%</span>
          </>
        )}
      </div>
    </div>
  );
}
